import { PaginationControls } from '../../../pagination';

interface TablePaginationProps {
  pageIndex: number;
  pageSize: number;
  totalItems: number;
  pageCount: number;
  currentRowsCount: number;
  onChangePage: (page: number) => void;
  onChangePageSize: (pageSize: number) => void;
  hidePageSizeDropdown: boolean;
  isNarrow?: boolean;
}

export const TablePagination = ({
  pageIndex,
  pageSize,
  totalItems,
  pageCount,
  currentRowsCount,
  onChangePage,
  onChangePageSize,
  hidePageSizeDropdown,
  isNarrow,
}: TablePaginationProps) => {
  const fromItems = pageIndex * pageSize + 1;
  const toItems = fromItems + currentRowsCount - 1;

  return (
    <PaginationControls
      currentPageIndex={pageIndex}
      totalPages={pageCount}
      fromItems={fromItems}
      toItems={toItems}
      pageSize={pageSize}
      totalItems={totalItems}
      onPageChange={onChangePage}
      onPageSizeChange={onChangePageSize}
      hidePageSizeDropdown={hidePageSizeDropdown}
      isNarrow={isNarrow}
    />
  );
};
